import React, { useState } from 'react'
import Select from 'react-select'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import DateRangePicker from '../../components/reusable/rangePicker'

const Transactions = ({ namespace }) => {
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState()
    const [method, setMethod] = useState()
    const [subject, setSubject] = useState()
    const [methods, setMethods] = useState([])

    const [
        { loading, error, fetch },
        { list: transactions },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('transactions', ranges ?
        { string, subject: subject?.value, method: method?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null }
        : { string, subject: subject?.value, method: method?.value }
        , { notify: true, manual: false })

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectMethod = mth => {
        setMethod(mth)
        refresh()
    }

    usePet('paymentMethodNames', null, { notify: true, callback: ({ data }) => setMethods(data) })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <DateRangePicker value={ranges} selectRange={selectRange} />
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Payments</h2>
                    <Select
                        className="mb-3"
                        value={method}
                        isClearable
                        onChange={selectMethod}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={methods.map(method => ({ label: method, value: method, amount: 0 }))}
                        placeholder="Select payment method" />
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                transactions.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Amount</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Subject</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Details</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Description</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Recorded By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                transactions.map((transaction, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {((page - 1) * limit) + (key + 1)}
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">Ksh. {transaction?.amount}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{transaction?.subjectName}</div>
                                                            <p className="text-gray-700 text-xs italic mb-0">{transaction?.subjectType}</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{transaction?.method}</div>
                                                            {transaction?.ref && <p className="text-gray-700 text-xs italic mb-0">#{transaction?.ref}</p>}
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{transaction?.description}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{transaction?.recordedBy?.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{stringifyDate(transaction.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">No transactions were found</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Transactions